import { getStatusColors } from "@/components/table-utils/get-status-color";
import TableRowActionGroup from "@/components/table-utils/table-row-action-group";
import routes from "@/routers/routes";
import AvatarCard from "@/ui/avatar-card";
import DateCell from "@/ui/date-cell";
import { createColumnHelper } from "@tanstack/react-table";
import { Link } from "react-router-dom";
import { Badge, Checkbox, Text } from "rizzui";
import { Category } from "@/types";

const columnHelper = createColumnHelper<Category>();

export const categoryListColumns = [
    columnHelper.display({
        id: "select",
        size: 50,
        header: ({ table }) => (
            <Checkbox
                className="ps-3.5"
                aria-label="Select all Rows"
                checked={table.getIsAllPageRowsSelected()}
                onChange={() => table.toggleAllPageRowsSelected()}
            />
        ),
        cell: ({ row }) => (
            <Checkbox
                className="ps-3.5"
                aria-label="Select Row"
                checked={row.getIsSelected()}
                onChange={row.getToggleSelectedHandler()}
            />
        ),
    }),
    columnHelper.accessor("name", {
        id: "name",
        size: 150,
        header: "Name",
        enableSorting: false,
        cell: ({ row }) => (
            <AvatarCard src={""} name={row.original.name} />
        ),
    }),
    columnHelper.accessor("description", {
        id: "description",
        size: 250,
        header: "Description",
        cell: ({ row }) => <Text>{row.original?.description ?? ""}</Text>,
    }),

    columnHelper.accessor("createdDate", {
        id: "createdDate",
        size: 150,
        header: "Created Date",
        cell: ({ row }) => (
            <DateCell date={new Date(row.original.createdDate)} />
        ),
    }),
];
